import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  search: "",
  type: "",
  page: 1,
};

// create slice
const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilterSearch: (state, action) => {
      state.search = action.payload;
    },
    clearSearch: (state) => {
      state.search = "";
    },
    setFilterType: (state, action) => {
      if (state.type === action.payload) state.type = "";
      else state.type = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    clearAllFilter: () => {
      return initialState;
    },
  },
});

export default filterSlice.reducer;
export const {
  setFilterType,
  setFilterSearch,
  clearSearch,
  setPage,
  clearAllFilter,
} = filterSlice.actions;
